import api from 'Application/api/api';

const getPoints = (cancelToken = null) =>
    api.get(`project-manager/projects/introductions/points`, {
        cancelToken,
    });

export default getPoints;
